import PropTypes from 'prop-types';
import React, { Component }  from 'react';
import classNames from 'classnames';
import NodeHeader from './NodeHeader';
import NodeContent from './NodeContent';
import AnimateHeight from 'react-animate-height';
// import Logging from '~app/core/logging';

// const log = Logging.getLogger('app.components.node');

class Node extends Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    info: PropTypes.object.isRequired,
    select: PropTypes.func,
    isSelected: PropTypes.bool,
  }

  state = {
    showContent: false,
  }

  toggleContent = () => {
    this.setState({showContent: !this.state.showContent});
  }

  render() {
    return (
      <div className={classNames("Node", 
                                 `Node--${this.props.info.className}`,
                                 this.props.isSelected?'Node--selected':'')}>
        <NodeHeader index={this.props.index} 
                    title={this.props.info.title} 
                    onShowContent={this.toggleContent} 
                    onSelect={this.props.select}
                    isOpen={this.state.showContent}/>
        <AnimateHeight duration={200} height={this.state.showContent?'auto':0}>
          <NodeContent node={this.props.info}/>
        </AnimateHeight>
      </div>
    );
  }
}

export default Node;



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/Node.js